class SearchUrlParamBuilder {
	build(baseUrl = '', filtros = {}, paginacao = {}) {
		filtros = Object.fromEntries(Object.entries(filtros).filter(([_, v]) => v != null));
		const possuiFiltros = !!Object.entries(filtros).some(([key, value]) => value != null);
		const possuiPaginacao = !!Object.entries(paginacao).some(([key, value]) => value != null);

		const paramFiltros = this.montarFiltros(filtros)
		const paramPaginacao = this.montarPaginacao(paginacao, possuiFiltros)
		return `${baseUrl}${possuiFiltros || possuiPaginacao ? '?' : ''}${paramFiltros}${paramPaginacao}`
	}

	montarFiltros(filtros){
		this.validarFiltros(filtros)
		const param = Object.entries(filtros).map(([key, value]) =>{
			return `${key}=${value}`
		})
		return param.length > 0 ? `${param.join('&')}` : ''
	}

	validarFiltros(filters) {
		const pagingAndSortingKeys = ['page', 'rowsPerPage', 'sort', 'sortBy']

		for (const key of pagingAndSortingKeys) {
			if (filters.hasOwnProperty(key)) {
				throw new TypeError(`O atributo "${key}" não pode ser utilizado nos filtros.`)
			}
		}
	}

	montarPaginacao(pagingAndSorting, hasFilters) {
		let param = ''

		if (pagingAndSorting.page) {
			param += `&page=${pagingAndSorting.page}`
		}

		if (pagingAndSorting.rowsPerPage) {
			param += `&rowsPerPage=${pagingAndSorting.rowsPerPage}`
		}

		if (pagingAndSorting.sortBy) {
			param += `&sortBy=${pagingAndSorting.sortBy}`
			param += `&sort=${pagingAndSorting.descending ? 'DESC': 'ASC'}`
		}


		if (!hasFilters) {
			param = param.length > 0 ? param.substr(1) : param
		}

		return param
	}
}

export default new SearchUrlParamBuilder()
